import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectBoardUserAcquired, selectBoardUserAcquiring } from "src/app/store/device/device.selector";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";

@Component({
	templateUrl: './acquire-board-user.dialog.component.html',
})

export class AcquireBoardUserDialogComponent implements OnInit, OnDestroy {
	boardUserAcquiring: boolean;
	boardUserAcquiring$: Observable<boolean | undefined>;
	boardUserAcquiringSub: Subscription

	boardUserAcquired: boolean;
	boardUserAcquired$: Observable<boolean | undefined>;
	boardUserAcquiredSub: Subscription;

	loadingValue = 20;

	interval: any;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.boardUserAcquiring$ = this.store.select(selectBoardUserAcquiring);
		this.boardUserAcquired$ = this.store.select(selectBoardUserAcquired);
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.startAcquisition();
	}

	ngOnDestroy(): void {
		this.boardUserAcquiringSub?.unsubscribe();
		this.boardUserAcquiredSub?.unsubscribe();
	}

	subscribeAll(): void {
		this.boardUserAcquiringSub = this.boardUserAcquiring$
			.subscribe((aquiring) => {
				this.boardUserAcquiring = aquiring;
			}
			);
		this.boardUserAcquiredSub = this.boardUserAcquired$
			.pipe(filter(d => !!d))
			.subscribe(() => {
				this.ref.close();
			}
		);
	}

	startAcquisition(): void {
		this.loadingValue = 20;
		setTimeout(() => { // stops loading after 22secs
			clearInterval(this.interval);
			this.ref.close();
		}, 22000);
		this.interval = setInterval(() => { // spinner loader grows at every 220ms
			this.loadingValue -= 1;
		}, 1000);
		this.store.dispatch(DeviceActions.acquireBoardUser());
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
